import axios from "axios";
import { Link } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import React, { useState, useEffect } from "react";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";
import { API_Link, validateHeader } from "../commons/Constants";

const AdminRoleListingComponent = () => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const users = JSON.parse(localStorage.getItem("user"));
  const token = users.token;
  const MD5hash = validateHeader();
  const getRoles = () => {
    setIsLoading(true);
    var config = {
      method: "get",
      url: `${API_Link}getRoles`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setRoles(resData.data.roles);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div className="page--content ">
      <div className="row sticky-title align-items-center">
        <div className="col-md-6 col-lg-6">
          <h1 className="page--heading ">Role Listing</h1>
        </div>
        <div className="col-sm-6 col-xs-12 text--align--right ">
          {/* <a href="addreview" className="tem--add--btn"></a> */}
          <Link to="/admin/addrole" className="tem--add--btn">
            <IoIosAdd /> Add New Role
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="padding-table">
          <div className="table--template">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Role</th>
                  <th>Description</th>
                  <th>Landing Page</th>
                  {/* <td>Action</td> */}
                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  roles &&
                  roles?.map((role, index) => (
                    <tr>
                      <td>{index + 1} </td>
                      <td>
                        {role?.role.charAt(0).toUpperCase() +
                          role?.role.slice(1)}
                      </td>
                      <td> {role?.description}</td>
                      <td> {role?.landingpage}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="role-listing-loader d-flex">
                <Loader2 />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRoleListingComponent;
